function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.964 11.898c-2.1-.688-4.161-.169-6.029.599-1.77.727-3.176 2.197-4.463 3.614-5.72 6.3-8.79 16.85-14.079 21.293C15.857 40.24.263 40.048.263 40.048c3.66 1.898-1.668 2.687 2.223 3.613.927.22-2.64 2.455 1.483 2.408.79-.01-1.667 2.687 1.483 2.409 1.953-.173-.463 1.945 1.714 1.436 1.398-.328 8.19-5.157 10.376-4.727C20.923 45.85 26.348 47.538 31 47c6.858-.794 10.8-4.468 14-9 2.818-3.99 3.777-9.599 3.343-14.267C48.343 23.733 54 23 55 22c-3-1-4-1-6-2 0 0 .685-6.227-5.036-8.102z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.4 17.3a1 1.5 0 11-2 0 1 1.5 0 112 0z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.3 17.3a.3.3 0 11-.6 0 .3.3 0 11.6 0z",
  strokeWidth: 1.0002,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.7 37.46c-1.283 1.328-3.048 3.789-3.085 1.72-.043-2.44-3.158 2.859-3.415 1.01-.355-2.562-3.055 2.243-3.281.421-.284-2.288-3.808 3.188-3.609.161.115-1.755-3.543 2.352-3.414-.055.12-2.22-3.806 1.078-4.199-.306 6.037-5.5 6.72-7.383 11.058-12.426 1.181-1.374 3.87-7.076 9.138-6.198 3.259.544 5.267 4.39 4.25 8.955-.368 2.49-2.16 5.39-3.443 6.718z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 46.5c5 10-2 8.5 8 8.5M25 46.5c5 10-2 8.5 8 8.5M31 47c3 8-3 5 7 5"
}));

var SvgBird = function SvgBird(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBird, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bird.3f4c2801.svg";
export { ForwardRef as ReactComponent };